module.exports = "<span *ngIf=\"bemObject\">\n    <strong *ngIf=\"showOdometro\">{{labelOdometro}} </strong>\n    <strong *ngIf=\"!showOdometro\">{{labelHorimetro}} </strong>\n    <span *ngIf=\"odometroHorimetroObject\">{{odometroHorimetroObject.odometroHorimetro | odometroHorimetroMask}}</span>\n    <i *ngIf=\"!odometroHorimetroObject && (odometroHorimetroObject != 0)\">não cadastrado</i>\n</span>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/manutencoes/odometros-horimetros/odometro-horimetro-label/odometro-horimetro-label.component.html
 ** module id = 960
 ** module chunks = 0
 **/